import * as React from "react";

export default () => {
  return (
    <div>
      Hantera avtal i systemet som är kopplat till detta förvaltningsavtal.{" "}
    </div>
  );
};
